import { Component, OnInit } from '@angular/core';
import { WorkspaceService } from '../services/workspace.service';
import { PrimaryWorkspaceModel } from '../model/Engagement/CreateEngagementData';
import { Employee } from '../model/Workspace/Employee';
import { SearchEmployeeModel } from '../model/Workspace/SearchEmployeeModel';
import { AssignmentRequest } from 'src/app/model/Workspace/AssignmentRequest';
import { CreateAssignmentRequestModel } from 'src/app/model/Workspace/CreateAssignmentRequestModel';
import { AlertsService } from '../services/alerts.service';
import { Router } from '@angular/router';
import { CMSService } from '../services/cmsservice.service';
import { GraphService } from '../services/Integration/graphservice.service';
import { LoadingScreenService } from '../services/loading-screen.service';
import { AssignmentResponseList, AssignmentResponse } from '../model/Workspace/AssignmentResponse';
import { Alert } from '../model/Alert';
import { WorkspaceModel } from '../model/WorkspaceModel';

@Component({
  selector: 'app-process-cms-error-assignment',
  templateUrl: './process-cms-error-assignment.component.html',
  styleUrls: ['./process-cms-error-assignment.component.css']
})
export class ProcessCmsErrorAssignmentComponent implements OnInit {

  alert: Alert = new Alert();

  constructor(private workspaceService: WorkspaceService,
    private _alertService: AlertsService,
    private route: Router,
    private cmsService: CMSService,
    private graphSerivce: GraphService,
    private loadingScreenService: LoadingScreenService) { }

  workspaceId: string;
  workspaceModel: PrimaryWorkspaceModel = new PrimaryWorkspaceModel();
  employeeList: Employee[] = [];
  userInfo: any;
  placeholder: string = "Enter review id";
  CurrentWorkspaceData: WorkspaceModel = new WorkspaceModel();

  ngOnInit() {
    this._alertService.remove(this.alert);
  }
  processCMSErrorRequest() {
    this._alertService.remove(this.alert);
    this.getWorkspaceData(this.workspaceModel.workspaceId);
    this.workspaceService.ProcessCMSErrorRequest(this.workspaceModel.workspaceId).subscribe(
      result => {
        console.log('process assignment request result : ', result);
        if (result) {
          this.onApprove();
        } else {
          this._alertService.remove(this.alert);
          const message = 'The engagement could not be processed for CMS request as it did not satisfy the needed criteria';
          console.error(message);
          this._alertService.add(message, 'danger', null);
        }
      },
      error => {
        console.error('Error processing process cms error request ', error);
      });
  }

  onApprove() {
    this.workspaceService.CheckRequestSentForClient(this.workspaceModel.workspaceId.toString(), 0, 1).subscribe(result => {
      if (result === 1) {
        this.loadingScreenService.startLoading();
        //passing second parameter(assignmentCodeId) as 0 in review case
        this.workspaceService.getPrimaryAssignment(this.workspaceModel.workspaceId.toString(), null, null)
          .subscribe(
            assignmentRequestList => {
              if (assignmentRequestList.length > 0) {
                for (const assignmentRequest of assignmentRequestList) {
                  console.log('data from getPrimaryAssignment ', assignmentRequest);

                  if (!this.checkUserExistance(assignmentRequest.initiated_By_Email)) {
                    this.employeeList.push(new Employee('0', assignmentRequest.initiated_By_Email));
                  }
                  if (!this.checkUserExistance(assignmentRequest.client_Administrator_Email)) {
                    this.employeeList.push(new Employee('0', assignmentRequest.client_Administrator_Email));
                  }
                  if (!this.checkUserExistance(assignmentRequest.assignment_Administrator_Email)) {
                    this.employeeList.push(new Employee('0', assignmentRequest.assignment_Administrator_Email));
                  }
                  if (!this.checkUserExistance(assignmentRequest.engagement_Partner_Email)) {
                    this.employeeList.push(new Employee('0', assignmentRequest.engagement_Partner_Email));
                  }
                }

                console.log('To get the employee ids for given user list ', this.employeeList);

                const searchEmployee = new SearchEmployeeModel();
                searchEmployee.employees = this.employeeList;

                this.graphSerivce.GetEmployeeIdForUserList(searchEmployee).subscribe(
                  finalEmployeeList => {

                    console.log('API response for employee ids for given user list ', finalEmployeeList);
                    for (const assignmentRequestInner of assignmentRequestList) {
                      assignmentRequestInner.initiated_By
                        = finalEmployeeList.find(item => item.employeeEmailId === assignmentRequestInner.initiated_By_Email)
                          .employeeId;
                      assignmentRequestInner.client_Administrator
                        = finalEmployeeList.find(item => item.employeeEmailId === assignmentRequestInner.client_Administrator_Email)
                          .employeeId;
                      assignmentRequestInner.assignment_Administrator
                        = finalEmployeeList.find(item => item.employeeEmailId === assignmentRequestInner.assignment_Administrator_Email)
                          .employeeId;
                      assignmentRequestInner.engagement_Partner
                        = finalEmployeeList.find(item => item.employeeEmailId === assignmentRequestInner.engagement_Partner_Email)
                          .employeeId;

                      console.log('Updated Assignment Request ', assignmentRequestList);
                    }
                    const request = this.convertAssignmentRequestListToCreateAssignmentRequest(assignmentRequestList);
                    this.cmsService.PostPrimaryAssignmentFinance(request).subscribe(
                      assignmentResponse => {console.log('Successfully submission of CMS Primary Assignment.', assignmentResponse);
                         var assignmentResponseList = new AssignmentResponseList();
                        assignmentResponseList.list = [];
                        for (const item of assignmentResponse.data.assignmentResponse) {
                          var assignmentResponseLog = new AssignmentResponse();
                          assignmentResponseLog.assignmentCodeId = item.assignmentCodeId;
                          assignmentResponseLog.responseStatus = item.responseStatus;
                          assignmentResponseLog.api = assignmentResponse.engageFinanceIntegrationDetail?.endpoint;
                          assignmentResponseLog.requestBody = assignmentResponse.engageFinanceIntegrationDetail?.requestBody;
                          assignmentResponseLog.responseBodyForMoreThanOneAssignment = assignmentResponse.engageFinanceIntegrationDetail?.responseBody;
                          assignmentResponseLog.errorDetail = item.errorDetail;
                          assignmentResponseLog.requestDate = assignmentResponse.engageFinanceIntegrationDetail?.requestDateTime;
                          assignmentResponseLog.responseDate = assignmentResponse.engageFinanceIntegrationDetail?.responseDateTime;
                          assignmentResponseLog.requestBy = this.userInfo.loggedInUserEmail;
                          assignmentResponseLog.requestStatus = assignmentResponse.engageFinanceIntegrationDetail?.requestStatus;
                          assignmentResponseList.list.push(assignmentResponseLog);
                        }
                        this.workspaceService.storeFinanceLog(assignmentResponseList).subscribe(
                          logResult => {

                            for (let i = 0; i < assignmentResponse.data.assignmentResponse.length; i++) {
                              this.workspaceService
                                .updateFirstAssignmentStatus(assignmentResponse.data.assignmentResponse[i].responseStatus, assignmentResponse.data.assignmentResponse[i].assignmentCodeId)
                                .subscribe(
                                  statusResult => {
                                    console.log(statusResult);
                                  }
                                );
                            }

                            let finalStatus = '';
                            finalStatus = assignmentResponse.data.assignmentResponse.some(x => x.responseStatus == "Failure") ? "Failure" : "Success";
                            this._alertService.remove(this.alert);
                            const message = finalStatus == 'Failure'
                              ? 'The engagement could not be processed for CMS request'
                              : 'The engagement is successfully processed for CMS request';
                            const mType = finalStatus == 'Failure' ? 'danger' : 'success';
                            this._alertService.add(message, mType, null);

                            console.log('storeFinanceLog func response ', logResult);
                          },
                          logError => {
                            this.loadingScreenService.stopLoading();
                            console.log('Error in getting the response in storeFinanceLog in EDP API ', logError);
                          }

                        );
                      },
                      error => {
                        this.loadingScreenService.stopLoading();
                        console.log('Error in getting the response in Create in Finance Integration API ', error);
                      }
                    );
                  },
                  error => {
                    this.loadingScreenService.stopLoading();
                    console.log('Error in getting the response in GetEmployeeIdForUserList in Graph API ', error);
                  }
                );
              }
              else {
                console.log('No assignment found. So redirect to my engagements.');
                this.loadingScreenService.stopLoading();
                this.route.navigate(['/MyEngagements']);
              }

            },
            error => {
              this.loadingScreenService.stopLoading();
              console.log('Error in getting the response in getPrimaryAssignment in API ', error);
            });
        this.loadingScreenService.stopLoading();

      } else {
        if (result === 2) {
          this._alertService.remove(this.alert);
          const message = 'The engagement marked as E-Sign then CMS Request cannot be sent.';
          console.error(message);
          this._alertService.add(message, 'danger', null);
        }
      }
    },
      err => {
        this.loadingScreenService.stopLoading();
        console.error('Error processing CheckRequestSentForClient ', err);
      });
  }

  checkUserExistance(email: string): boolean {
    return this.employeeList.some(r => r.employeeEmailId === email);
  }
  convertAssignmentRequestListToCreateAssignmentRequest(list: AssignmentRequest[]){
    
    // Since all items share the same client info, we take the first record to populate the client model
    const firstItem = list[0];

    const result = new CreateAssignmentRequestModel();

     result.region = this.CurrentWorkspaceData.clientRegion;

    // 1. Map Client Data
    result.client = {
        clientCode: firstItem.client_Code,
        oneViewAccountId: firstItem.oneViewAccountId,
        clientType: firstItem.client_Type,
        clientName: firstItem.client_Name,
        clientAdministrator: firstItem.client_Administrator,
        addressLine1: firstItem.address_Line_1,
        addressLine2: firstItem.address_Line_2,
        addressLine3: firstItem.address_Line_3,
        addressLine4: firstItem.address_Line_4,
        city: firstItem.city,
        state: firstItem.state,
        country: firstItem.country,
        postalCode: firstItem.postal_Code,
        phone: firstItem.phone,
        fax: firstItem.fax,
        clientContactName: firstItem.client_Contact_Name,
        contactTypeCode: firstItem.contact_Type_Code,
        sicCode: firstItem.siC_Code,
        sicDescription: firstItem.siC_Description,
        industryCode: firstItem.industry_Code,
        industryDescription: firstItem.industry_Description,
        international: firstItem.international,
        transnational: firstItem.transnational,
        referralSourceCode: firstItem.referral_Source_Code,
        strucEntityCode: firstItem.struc_Entity_Code,
        strucEntityDesc: firstItem.struc_Entity_Desc,
        stockExchangeCode: firstItem.stock_Exchange_Code,
        stockExchangeDescription: firstItem.stock_Exchange_Description,
        tickerSymbol: firstItem.ticker_Symbol,
        clientFiscalYear: firstItem.client_Fiscal_Year,
        clientAcceptanceFlag: firstItem.client_Acceptance_Flag,
        attestationEngFlag: firstItem.attestation_Eng_Flag,
        backGroundCheckDate: firstItem.backGround_Check_Date,
        rilRequired: firstItem.riL_Required,
        rilAddedDate: firstItem.riL_Added_Date,
        independenceRules: firstItem.independence_Rules,
        independenceType: firstItem.independence_Type,
        clientFirstName: firstItem.client_First_Name,
        clientMiddleName: firstItem.client_Middle_Name,
        clientLastName: firstItem.client_Last_Name
    };

    // 2. Map Assignments Array
    result.assignments = list.map(item => ({
        initiatedBy: item.initiated_By,
        contactCompensationFlag: item.contact_Compensation_Flag,
        assignmentName: item.assignment_Name,
        assignmentAdministrator: item.assignment_Administrator,
        engagementPartner: item.engagement_Partner,
        engagementTypeCode: item.engagement_Type_Code,
        solutionCode: String(item.solution_Code),
        ratesetRealization: String(item.rateset_Realization),
        estimatedRevenue: String(item.estimated_Revenue),
        approvalDate: item.approval_Date,
        engagementId: Number(item.engagement_Id), 
        assignmentCodeId: Number(item.engagement_Solution_Assignment_Code_Id),
        engagementStartDate: item.engagement_Start_Date,
        engagementEndDate: item.engagement_End_Date,
        estimatedGrossMargin: item.estimated_Gross_Margin,
        officeLocationCode: item.office_Location_Code,
        billingContactTitleCode: item.billing_Contact_Title_Code,
        billingClientContactEmail: item.billing_Client_Contact_Email,
        billingClientContactName: item.billing_Client_Contact_Name
    }));

    return result;
  }
  getWorkspaceData(id: string) {
    this.workspaceService.getWorkspaceById(id).subscribe(
      result => {
        this.CurrentWorkspaceData = result;     
      });
  }
}
